import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API from "../Context/api";

function ViewLocalPurchaseOrder() {
  const { id } = useParams();
  const [lpo, setLpo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLpo = async () => {
      try {
        const response = await API.get(`/localpurchaseorders/${id}`);
        setLpo(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch LPO");
      } finally {
        setLoading(false);
      }
    };

    fetchLpo();
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error) return <p>Error: {error}</p>;
  if (!lpo) return <p>No LPO found</p>;

  const { lpoHeader, lpoDetails } = lpo;
  const { companyName, companyTIN, address, phone, email, description } =
    lpoHeader;
  const {
    lpoNo,
    date,
    client,
    clientLocation,
    items,
    subTotal,
    vat,
    grandTotal,
  } = lpoDetails;

  const handlePrint = () => {
    window.print();
  };

  return (
    // <div className="max-w-4xl mx-auto p-6 bg-white">
    //   <div className="text-center mb-6">
    //     <h1 className="text-3xl font-bold text-gray-800">{companyName}</h1>
    //     <p className="text-sm text-gray-600">
    //       TIN: {companyTIN} | {address}, Tel: {phone}
    //       <br />
    //       Email: {email.join(", ")}
    //     </p>
    //     <p className="text-sm text-gray-600 mt-2">{description}</p>
    //   </div>
    //   <div className="flex justify-between items-center mb-4">
    //     <h2 className="text-xl font-semibold">LOCAL PURCHASE ORDER</h2>
    //     <div className="flex items-center space-x-4">
    //       <div>
    //         <p>
    //           No. <span className="font-bold">{lpoNo}</span>
    //         </p>
    //         <p>
    //           Date:{" "}
    //           <span className="font-bold">
    //             {new Date(date).toLocaleDateString()}
    //           </span>
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="mb-4">
    //     <p className="" style={{ whiteSpace: "pre-wrap" }}>
    //       {clientLocation}
    //     </p>
    //     <p className=" font-semibold mt-4">
    //       Attn: <span className="">{client}</span>
    //     </p>
    //   </div>
    //   <div className="mb-4">
    //     <table className="w-full border border-collapse">
    //       <thead>
    //         <tr className="border">
    //           <th className="text-left p-2 border">S/No</th>
    //           <th className="text-left p-2 border">Description</th>
    //           <th className="text-left p-2 border">U.O.M</th>
    //           <th className="text-left p-2 border">Qty</th>
    //           <th className="text-left p-2 border">Unit Price (USD)</th>
    //           <th className="text-left p-2 border">Total Price (USD)</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         {items.map((item, index) => (
    //           <tr key={index} className="border">
    //             <td className="p-2 border">{index + 1}</td>
    //             <td className="p-2 border">{item.description}</td>
    //             <td className="p-2 border">{item.uom}</td>
    //             <td className="p-2 border">{item.quantity}</td>
    //             <td className="p-2 border">{item.unitPrice}</td>
    //             <td className="p-2 border">{item.totalPrice}</td>
    //           </tr>
    //         ))}
    //         <tr className="border">
    //           <td colSpan="5" className="p-2 border font-semibold">
    //             SUB Total
    //           </td>
    //           <td className="p-2 border">{subTotal.toLocaleString()}</td>
    //         </tr>
    //         <tr className="border">
    //           <td colSpan="5" className="p-2 border font-semibold">
    //             VAT 18%
    //           </td>
    //           <td className="p-2 border">{vat.toLocaleString()}</td>
    //         </tr>
    //         <tr className="border font-bold">
    //           <td colSpan="5" className="p-2 border">
    //             GRAND TOTAL
    //           </td>
    //           <td className="p-2 border">{grandTotal.toLocaleString()}</td>
    //         </tr>
    //       </tbody>
    //     </table>
    //   </div>
    //   <div className="">
    //     <p>General Terms: IMMEDIATE</p>
    //     <p>Payment: Advance</p>
    //     <p>Warranty: Full Manufacturer's Warranty One year</p>
    //   </div>
    //   <div className="mt-4">
    //     {/* <p>Signed: _____________________</p> */}
    //     <p>On behalf of Kevmark Investment Limited</p>
    //     {/* <p className="text-sm">for: {companyName}</p> */}
    //     <br />
    //     <br />
    //     <p className="font-bold">Nakyanzi Rita</p>
    //     Director Sales
    //   </div>
    //   <button
    //     onClick={handlePrint}
    //     className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print:hidden mt-4"
    //   >
    //     Print
    //   </button>
    // </div>
    <div className="max-w-3xl mx-auto p-4 sm:p-6 bg-white border border-gray-300 rounded-lg shadow-sm my-8">
      {/* Header */}
      <div className="text-center mb-6 border border-gray-200 rounded-md p-3 sm:p-4">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
          <img
            src="/images/logo.png"
            alt="Company Logo"
            className="h-20 w-20 mr-2 inline-block"
          />{" "}
          {companyName}
        </h1>
        <p className="text-xs sm:text-sm text-gray-600 mt-2 leading-relaxed">
          TIN: {companyTIN} | {address}, Tel: {phone}
          <br />
          Email: {email.join(", ")}
        </p>
        <p className="text-xs sm:text-sm text-gray-600 italic mt-1">
          {description}
        </p>
      </div>

      {/* LPO Title */}
      <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-3">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 uppercase tracking-wide">
          Local Purchase Order
        </h2>
        <div className="text-right">
          <p className="text-xs sm:text-sm text-gray-700">
            No. <span className="font-bold text-gray-900">{lpoNo}</span>
          </p>
          <p className="text-xs sm:text-sm text-gray-700">
            Date:{" "}
            <span className="font-bold text-gray-900">
              {new Date(date).toLocaleDateString()}
            </span>
          </p>
        </div>
      </div>

      {/* Client Info */}
      <div className="mb-6 bg-gray-50 p-3 sm:p-4 rounded-md border border-gray-200">
        <p
          className="text-xs sm:text-sm text-gray-700"
          style={{ whiteSpace: "pre-wrap" }}
        >
          {clientLocation}
        </p>
        <p className="text-base sm:text-lg font-semibold text-gray-800 mt-2">
          Attn: <span>{client}</span>
        </p>
      </div>

      {/* Table */}
      <div className="mb-6">
        <div className="overflow-x-auto border border-gray-200 rounded-md">
          <table className="w-full border-collapse bg-white text-xs sm:text-sm">
            <thead>
              <tr className="bg-gray-100 text-gray-700 uppercase tracking-wider">
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  S/No
                </th>
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  Description
                </th>
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  U.O.M
                </th>
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  Qty
                </th>
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  Unit Price (USD)
                </th>
                <th className="p-2 sm:p-3 text-right font-medium border-b border-gray-200">
                  Total Price (USD)
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150"
                >
                  <td className="p-2 sm:p-3 text-gray-700">{index + 1}</td>
                  <td className="p-2 sm:p-3 text-gray-700">
                    {item.description}
                  </td>
                  <td className="p-2 sm:p-3 text-gray-700">{item.uom}</td>
                  <td className="p-2 sm:p-3 text-gray-700">{item.quantity}</td>
                  <td className="p-2 sm:p-3 text-gray-700">
                    {item.unitPrice.toLocaleString()}
                  </td>
                  <td className="p-2 sm:p-3 text-gray-700 text-right">
                    {item.totalPrice.toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr className="border-t border-gray-200 bg-gray-50">
                <td
                  colSpan="5"
                  className="p-2 sm:p-3 text-left font-semibold text-gray-800"
                >
                  SUB Total
                </td>
                <td className="p-2 sm:p-3 text-right text-gray-800">
                  {subTotal.toLocaleString()}
                </td>
              </tr>
              <tr className="border-t border-gray-200">
                <td
                  colSpan="5"
                  className="p-2 sm:p-3 text-left font-semibold text-gray-800"
                >
                  VAT 18%
                </td>
                <td className="p-2 sm:p-3 text-right text-gray-800">
                  {vat.toLocaleString()}
                </td>
              </tr>
              <tr className="border-t border-gray-200 bg-gray-100 font-bold">
                <td
                  colSpan="5"
                  className="p-2 sm:p-3 text-left text-gray-900 uppercase"
                >
                  GRAND TOTAL
                </td>
                <td className="p-2 sm:p-3 text-right text-gray-900">
                  {grandTotal.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Terms */}
      <div className="mb-6 p-3 sm:p-4 bg-gray-50 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          General Terms: IMMEDIATE
        </p>
        <p className="text-xs sm:text-sm text-gray-700">Payment: Advance</p>
        <p className="text-xs sm:text-sm text-gray-700">
          Warranty: Full Manufacturer's Warranty One year
        </p>
      </div>

      {/* Signature */}
      <div className="text-right mb-6">
        <p className="text-xs sm:text-sm text-gray-700">
          On behalf of {companyName}
        </p>
        <p className="text-xs sm:text-sm font-bold text-gray-800 mt-4">
          Nakyanzi Rita
        </p>
        <p className="text-xs sm:text-sm text-gray-600">Director Sales</p>
      </div>

      {/* Print Button */}
      <button
        onClick={handlePrint}
        className="w-full sm:w-auto bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 print:hidden text-xs sm:text-sm"
      >
        Print
      </button>
    </div>
  );
}

export default ViewLocalPurchaseOrder;
